import React from 'react';
import cn from 'classnames';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import BodyRow, { IBodyRowProps } from '../../BodyRow';

export interface IBodyRowDraggableProps extends IBodyRowProps {
  uniqueIdentifier?: number | string,
  bodyRowComponent?: React.ElementType,
  isDragAndDropDisabled?: boolean,
  draggingClassName?: string,
  topNeighborClassName?: string,
  bottomNeighborClassName?: string,
}

const BodyRowDraggable = ({
  bodyRowComponent: BodyRowComponent = BodyRow,
  draggingClassName,
  topNeighborClassName,
  bottomNeighborClassName,
  ...props
}: IBodyRowDraggableProps) => {
  const {
    active,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    activeIndex,
    index,
  } = useSortable({
    animateLayoutChanges: props.isAnimation ? () => true : undefined,
    id: props.uniqueIdentifier,
    disabled: props.isDragAndDropDisabled,
  });

  const style = {
    ...(active && {
      transition,
      transform: CSS.Translate.toString(transform),
    }),
    ...(isDragging && {
      position: 'relative',
      zIndex: 1,
    }),
  };

  const isTopNeighbor =
    (index !== 0 || (index === 0 && activeIndex === 1)) &&
    index === activeIndex - 1;

  const isBottomNeighbor =
    (index !== 0 || (index === 0 && activeIndex === 1)) &&
    index === activeIndex + 1;

  return (
    <BodyRowComponent
      ref={ setNodeRef }
      { ...props }
      style={ style }
      attributes={ attributes }
      listeners={ listeners }
      className={ cn({
        [draggingClassName]: isDragging,
        [topNeighborClassName]: isTopNeighbor,
        [bottomNeighborClassName]: isBottomNeighbor,
      }) }
    />
  );
};

export default BodyRowDraggable;
